/**
 * `locationId` is the place the punch is being made AT — the location the app
 * is switched to, which is already what the geofence is evaluated against.
 * Sending it makes the client's intent explicit instead of leaving the server
 * to fall back to whatever location the JWT was minted with: those differ the
 * moment someone switches shops, and the difference is a whole shift filed
 * against the wrong location. It also lets the clock tell "you are already
 * checked in HERE" from "you are still checked in SOMEWHERE ELSE".
 */
export function buildClockInPayload(device, location, locationId) {
    return {
        ...(locationId ? { location_id: locationId } : {}),
        device_fingerprint: device.device_fingerprint,
        device_name: device.device_name,
        device_os: device.device_os,
        device_type: device.device_type,
        app_version: device.app_version,
        latitude: location?.latitude,
        longitude: location?.longitude,
        gps_accuracy_meters: location?.gps_accuracy_meters,
    };
}
